<template>
    <BreadCrumb PageTitle="Liste des chefs quartiers" />
    <Listechefquartier/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Listechefquartier from "@/components/Assignations/listechefquartier.vue";
  
    export default defineComponent({
      name: "AddchefquartierPage",
      components: {
        BreadCrumb,
        Listechefquartier,
      },
    });
  </script>